import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import packageJson from '../../package.json'
import AuthLayout from 'layouts/AuthLayout'
import { getOnChangeFunction, getFormattedMissingFieldsMessage } from 'utils'
import { useAuth } from 'auth/AuthContext'
import { makeRequest } from 'services/request.service'
import { showAlert } from 'services/alerts.service'

const Login = () => {
  const { login } = useAuth()
  const navigate = useNavigate()
  const [credentials, setCredentials] = useState({ email: '', password: '' })
  const [error, setError] = useState('')

  const onChangeValue = getOnChangeFunction(setCredentials, credentials)

  const onSubmit = async (e) => {
    e.preventDefault()

    const htmlMessage = getFormattedMissingFieldsMessage(credentials, ['email', 'password'])
    if (htmlMessage !== '') {
      showAlert({
        title: 'Missing Fields',
        html: htmlMessage,
        icon: 'warning'
      })
      return
    }

    await loginRequest()
  }

  const loginRequest = async () => {
    try {
      const result = await makeRequest({
        method: 'post',
        url: '/login',
        data: credentials
      })

      if (!result || !result.data) {
        throw new Error('No data returned from server')
      }
      if (result.status === 200) {
        login(result.data)
        navigate('/dashboard/last-working-day-summary')
      }
    } catch (error) {
      console.error('Login Error:', error)

      if (error.response) {
        const { status } = error.response
        if (status === 401 || status === 403) {
          setError('Invalid email or password.')
          return
        }
      }
      setError('Something went wrong. Please try again.')
    }
  }

  return (
    <AuthLayout>
      <h2 className='text-xl font-semibold text-greenPrimary mb-4'>Login to your account</h2>
      <form className='w-full' onSubmit={onSubmit} autoComplete='off'>
        <div className='mb-4'>
          <label className='block text-gray-600 text-sm font-medium mb-1'>Email:</label>
          <input
            type='email'
            name='email'
            placeholder='Enter your email'
            value={credentials.email}
            onChange={onChangeValue}
            className='w-full px-3 py-2 border rounded-md bg-gray-100 focus:outline-none focus:ring-2 focus:ring-green-500'
          />
        </div>
        <div className='mb-6'>
          <label className='block text-gray-600 text-sm font-medium mb-1'>Password:</label>
          <input
            type='password'
            name='password'
            placeholder='Enter your password'
            value={credentials.password}
            onChange={onChangeValue}
            className='w-full px-3 py-2 border rounded-md bg-gray-100 focus:outline-none focus:ring-2 focus:ring-green-500'
          />
        </div>
        <button
          type='submit'
          className='w-full bg-greenPrimary text-white py-2 rounded-md hover:bg-green-900 transition'
        >
          Login
        </button>
        {error && <p className='text-red-600 text-sm mt-2 text-center'>{error}</p>}
      </form>
      <div className='text-center mt-4 text-sm text-gray-600'>
        Don’t have an account?{' '}
        <a href='/signup' className='text-greenPrimary font-semibold hover:underline'>
          Sign up here
        </a>
      </div>
      <p className='text-xs text-center text-gray-400 mt-4'>
        Version {packageJson.version}
      </p>
    </AuthLayout>
  )
}

export default Login
